import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { calculateAllWorkerFRI, getRoles, reCalculateAllWorkerHours } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import AccessForbidden from "../../../../Access/AccessForbidden";
import Loading from "../../../../../components/Loading/Loading";
import { toast } from "react-toastify";
import { Modal } from "antd";

const FRIButton = () => {
    const {state} = useAuth();
    const [isAdmin, setIsAdmin] = useState(false)
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [buttonHoursLoading, setButtonHoursLoading] = useState(false);
    
    const calculateAllWorkersFRI = async () => {
        setButtonLoading(true);
        const response = await calculateAllWorkerFRI(state.user?.token);
        if(response?.status === 200) {
            setButtonLoading(false)
            toast.success(response?.data?.message)
        };
    };

    const calculateAllWorkersHours = async () => {
        setButtonHoursLoading(true);
        const response = await reCalculateAllWorkerHours(state.user?.token);
        if(response?.success) {
            setButtonHoursLoading(false)
            toast.success(response?.message)
        };
    };

    const getAllRoles = async () => {
        const response = await getRoles(state.user?.token);
        if(response) {
            setLoading(false)
        }
        else{
            setIsAdmin(true);
        }
        setLoading(false);
    }

    useEffect(() => {
        getAllRoles();
    }, []);

    if(loading) {
        return <Loading />;
    }

    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <Box m={3} display={"flex"} flexDirection={"column"}>
            <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={buttonHoursLoading}
                style={{boxShadow: "none", backgroundColor: "#156bc2", width: 250, color: 'white', margin: 10}}
                onClick={() => 
                    Modal.confirm({
                        title: `This will re-calculate the hours for all workers. Do you want to continue?`,
                        onOk: () => calculateAllWorkersHours(),
                        okButtonProps: { danger: true },
                        okText: 'YES',
                        cancelText: 'NO',
                        centered: true
                    })
                }
            >
                Re-Calculate All Hours
            </Button>
            <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={buttonLoading}
                style={{boxShadow: "none", backgroundColor: "#156bc2", width: 320, color: 'white', margin: 10}}
                onClick={() => 
                    Modal.confirm({
                        title: `This will re-calculate the FRI and hours for all workers. Do you want to continue?`,
                        onOk: () => calculateAllWorkersFRI(),
                        okButtonProps: { danger: true },
                        okText: 'YES',
                        cancelText: 'NO',
                        centered: true
                    })
                }
            >
                Re-Calculate All Fatigues + Hours
            </Button>
        </Box>
    )
}

export default FRIButton;